import { Modal } from "antd";
import { t } from "i18next";
import * as React from "react";
import { useEffect } from "react";
import { useBlocker } from "react-router-dom";

export interface PropsPageBlocker {
  changed: () => boolean;
}

/**
 * Предотвращает переход на другую страницу, если в форме есть несохраненные изменения.
 * Использует NavBlocker в качестве базового механизма блокировки навигации.
 */
export const PageBlocker: React.FC<PropsPageBlocker> = ({ changed }) => {
  const [modal, modalContextHolder] = Modal.useModal();
  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      currentLocation.pathname !== nextLocation.pathname,
  );

  const checkChanges = () => {
    if (blocker.state !== "blocked") return;

    if (!changed()) {
      blocker.proceed();
      return;
    }
    modal.confirm({
      title: t("Continue with data loss"),
      content: t("Unsaved changes warning"),
      okText: t("Continue"),
      cancelText: t("Cancel"),
      onOk: () => blocker.proceed(),
      onCancel: () => blocker.reset(),
    });
  };

  useEffect(() => {
    checkChanges();
  }, [blocker, checkChanges]);

  return modalContextHolder;
};
